import React from "react";

interface ThemeSwitchProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

export const ThemeSwitch: React.FC<ThemeSwitchProps> = ({ theme, toggleTheme }) => {
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      className={`absolute top-5 right-5 w-9 h-9 rounded-xl border flex items-center justify-center transition-all active:scale-90 text-sm z-50 ${
        isDark
          ? "bg-[#1e1e22]/80 border-white/10 text-yellow-400 hover:bg-white/5"
          : "bg-white border-black/10 text-gray-700 hover:bg-black/5"
      }`}
      title="Cambiar tema"
    >
      {isDark ? "☀️" : "🌙"}
    </button>
  );
};
